import { useMemo } from 'react'
import {
  parseAsArrayOf,
  parseAsInteger,
  parseAsString,
  parseAsStringLiteral,
  useQueryStates,
} from 'nuqs'
import { DashboardStatusCategorySchema } from '@myapp/contract'
import type { DashboardMetric } from '../../../entities/dashboard'
import { getDashboardDefaults } from './dashboardFilters.logic'
import type { DashboardFiltersForm, DashboardPeriodMode } from './dashboardFilters.types'

const MODES = ['year', 'months'] as const satisfies readonly DashboardPeriodMode[]
const METRICS = ['count', 'cost', 'hours'] as const satisfies readonly DashboardMetric[]

export const useDashboardFiltersParams = () => {
  // Defaults depend on today, so they are fixed once per mount rather than at import time.
  const defaults = useMemo(() => getDashboardDefaults(new Date()), [])
  const parsers = useMemo(
    () => ({
      mode: parseAsStringLiteral(MODES).withDefault('months'),
      year: parseAsInteger.withDefault(defaults.year),
      from: parseAsString.withDefault(defaults.from),
      to: parseAsString.withDefault(defaults.to),
      gewerke: parseAsArrayOf(parseAsString).withDefault([]),
      technicianId: parseAsInteger,
      status: parseAsStringLiteral(DashboardStatusCategorySchema.options),
      metric: parseAsStringLiteral(METRICS).withDefault('cost'),
    }),
    [defaults],
  )
  return useQueryStates(parsers, { clearOnDefault: true })
}

export type DashboardFiltersParams = ReturnType<typeof useDashboardFiltersParams>[0]

export const toDashboardFiltersForm = (params: DashboardFiltersParams): DashboardFiltersForm => ({
  mode: params.mode,
  year: params.year,
  from: params.from,
  to: params.to,
  gewerke: params.gewerke,
  technicianId: params.technicianId,
  status: params.status,
  metric: params.metric,
})
